/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Storyblok_Webhook } from '../models/Storyblok_Webhook';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class StoryblokWebhookService {
    /**
     * Receive Storyblok Webhooks
     * This endpoint allows you to receive webhooks from Storyblok.
     * @returns any Yext synchronization skipped.
     * @throws ApiError
     */
    public static postWebhook({
        requestBody,
        apiVersion = 1,
    }: {
        requestBody: Storyblok_Webhook,
        apiVersion?: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v{apiVersion}/storyblok/webhook',
            path: {
                'apiVersion': apiVersion,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error.`,
            },
        });
    }
}
